import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import useSWR from 'swr';
import { PrismicRichText } from '@prismicio/react';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import * as prismic from '@prismicio/client';
import { Box } from '@yoweb/ui/components/Box';
import { Button } from '@yoweb/ui/components/buttons/Button';
import { ButtonIcon } from '@yoweb/ui/components/buttons/ButtonIcon';
import { Container } from '@yoweb/ui/components/containers/Container';
import { CloseIcon } from '@yoweb/ui/components/Icon/CloseIcon';
import { Link } from '@yoweb/ui/components/Link';
import { Text } from '@yoweb/ui/components/typography';
import { fetcher } from '@yoweb/utils/common';
import { API_GEO, API_PRISMIC, EMBED_PATH, PAGE_CAREERS, PAGE_CHECKOUT, PAGE_CONTACT_US, PAGE_COOKIE_POLICY, PAGE_COPYRIGHT_POLICY, PAGE_EMAIL_VERIFIED, PAGE_EMPLOYERS, PAGE_FAQ, PAGE_LOGIN_ERROR, PAGE_PRESS, PAGE_PRIVACY_POLICY, PAGE_TERMS_OF_SERVICE } from '@store/constants/routes';
import { getColor, getFontSize, getFontWeight, getSpace, getZIndex } from '@yoweb/ui/styles/utils/theme';
import { isSessionStorageSupported } from '@yoweb/utils/isSupported';
import { media } from '@yoweb/ui/styles/utils';
import { useExternalConfig } from '@store/contexts/ExternalConfig';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { REGION_GLOBAL } from '@store/constants/banner';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { isArray } from '@yoweb/utils/isArray';
import { htmlSerializerEmbed } from '@yoweb/ui/utils/prismic';
import { captureException } from '@yoweb/utils/sentry';
import { PrismicPageTypeRoutes } from '@yoweb/prismic-slicemachine/constants/routes';
import { RenderOn } from '@yoweb/ui/components/RenderOn/RenderOn';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
var BANNER_STATE_KEY = 'gift.banner';
var PAGE_EXCLUSION_LIST = [EMBED_PATH, PAGE_CAREERS, PAGE_CHECKOUT, PAGE_CONTACT_US, PAGE_COOKIE_POLICY, PAGE_COPYRIGHT_POLICY, PAGE_EMAIL_VERIFIED, PAGE_EMPLOYERS, PAGE_FAQ, PAGE_LOGIN_ERROR, PAGE_PRESS, PAGE_PRIVACY_POLICY, PAGE_TERMS_OF_SERVICE];
var BannerState;

(function (BannerState) {
  BannerState["visible"] = "visible";
  BannerState["hidden"] = "hidden";
})(BannerState || (BannerState = {}));

var lightBackgroundList = ['base000', 'base050', 'base100', 'base200', 'base400', 'baseA050', 'baseA200', 'baseA300', 'baseA400', 'beach', 'citrus', 'coral', 'criticalLight', 'evening', 'eveningLight', 'infoLight', 'morning', 'sky', 'skyLight', 'sprout', 'successLight', 'warningLight'];

var GiftBannerUI = function GiftBannerUI(_ref) {
  var bannerData = _ref.bannerData,
      onClose = _ref.onClose,
      onCtaClick = _ref.onCtaClick,
      onLoaded = _ref.onLoaded;

  var _useState = useState(false),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var _useState2 = useState(false),
      isEnabled = _useState2[0],
      setIsEnabled = _useState2[1];

  var hideBanner = function hideBanner() {
    sessionStorage.setItem(BANNER_STATE_KEY, BannerState.hidden);
    setIsVisible(false);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };

  var showBanner = function showBanner() {
    var visible = true;

    if (isSessionStorageSupported()) {
      var bannerState = sessionStorage.getItem(BANNER_STATE_KEY);

      if (!bannerState) {
        sessionStorage.setItem(BANNER_STATE_KEY, BannerState.visible);
      }

      visible = bannerState !== BannerState.hidden;
    }

    setIsVisible(visible);
    setIsEnabled(true);
    onLoaded === null || onLoaded === void 0 ? void 0 : onLoaded(visible);
  };

  useEffect(function () {
    showBanner(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isVisible || !isEnabled) {
    return null;
  }

  return /*#__PURE__*/_jsx(Wrap, {
    "data-testid": "gift-banner",
    children: /*#__PURE__*/_jsx(Container, {
      backgroundColor: bannerData.BackgroundColor,
      fillTabletWidth: true,
      children: /*#__PURE__*/_jsxs(Box, {
        alignItems: "center",
        display: {
          _: 'grid',
          md: 'flex'
        },
        gap: {
          _: 'small4',
          md: 'normal2'
        },
        justifyContent: "center",
        mx: {
          _: 'normal3',
          md: 'large1'
        },
        py: "normal1",
        children: [/*#__PURE__*/_jsxs(Text, {
          as: "span",
          size: "lg",
          textAlign: "left",
          variant: lightBackgroundList.includes(bannerData.BackgroundColor) ? 'primary' : 'inverse',
          children: [/*#__PURE__*/_jsx(RenderOn.MobileOnly, {
            children: /*#__PURE__*/_jsx(PrismicRichText, {
              components: htmlSerializerEmbed,
              field: isArray(bannerData.TextContentMobile, false) ? bannerData.TextContentMobile : bannerData.TextContent
            })
          }), /*#__PURE__*/_jsx(RenderOn.TabletAndDesktop, {
            children: /*#__PURE__*/_jsx(PrismicRichText, {
              components: htmlSerializerEmbed,
              field: bannerData.TextContent
            })
          }), bannerData.LinkURL && /*#__PURE__*/_jsx(StyledLink, {
            href: bannerData.LinkURL,
            hasUnderline: true,
            children: bannerData.LinkLabel || bannerData.LinkURL
          }, 0)]
        }), onCtaClick && bannerData.CtaButtonText && /*#__PURE__*/_jsx(Box, {
          alignContent: "start",
          children: /*#__PURE__*/_jsx(Button, {
            onClick: onCtaClick,
            children: bannerData.CtaButtonText
          })
        }), /*#__PURE__*/_jsx(Box, {
          position: "absolute",
          right: {
            _: -12,
            md: 'none'
          },
          top: {
            _: 'small4',
            md: 'auto'
          },
          children: /*#__PURE__*/_jsx(StyledCloseButton, {
            "data-testid": "gift-banner-hide-button",
            icon: /*#__PURE__*/_jsx(CloseIcon, {}),
            onClick: function onClick() {
              return hideBanner();
            },
            size: "sm",
            variant: lightBackgroundList.includes(bannerData.BackgroundColor) ? 'tertiary' : 'primary'
          })
        })]
      })
    })
  });
};

var fetchBannerItems = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    var predicates, url, _res$, res, _res$2, _data$slices, _data$slices$, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            predicates = [prismic.predicate.at('document.type', PrismicPageTypeRoutes.banner.type)];
            url = "".concat(API_PRISMIC, "?method=get&lang=").concat(locale).concat(predicates.reduce(function (sum, next) {
              return "".concat(sum, "&predicates=").concat(next);
            }, ''));
            _context.prev = 2;
            _context.next = 5;
            return fetchJson(url);

          case 5:
            res = _context.sent;

            if (!(Array.isArray(res) && res !== null && res !== void 0 && (_res$ = res[0]) !== null && _res$ !== void 0 && _res$.data)) {
              _context.next = 9;
              break;
            }

            data = res === null || res === void 0 ? void 0 : (_res$2 = res[0]) === null || _res$2 === void 0 ? void 0 : _res$2.data;
            return _context.abrupt("return", (data === null || data === void 0 ? void 0 : (_data$slices = data.slices) === null || _data$slices === void 0 ? void 0 : (_data$slices$ = _data$slices[0]) === null || _data$slices$ === void 0 ? void 0 : _data$slices$.items) || []);

          case 9:
            return _context.abrupt("return", []);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            captureException(_context.t0);
            return _context.abrupt("return", []);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 12]]);
  }));

  return function fetchBannerItems(_x) {
    return _ref2.apply(this, arguments);
  };
}();

export var GiftBanner = function GiftBanner(props) {
  var _useIntlMeta = useIntlMeta(),
      locale = _useIntlMeta.locale,
      country = _useIntlMeta.country;

  var _useRouter = useRouter(),
      asPath = _useRouter.asPath;

  var _useExternalConfig = useExternalConfig(),
      prismicConfig = _useExternalConfig.prismic;

  var _useSWR = useSWR(API_GEO, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    shouldRetryOnError: false
  }),
      geoResponse = _useSWR.data;

  var _useState3 = useState(),
      bannerData = _useState3[0],
      setBannerData = _useState3[1];

  var isOnExcludedPage = PAGE_EXCLUSION_LIST.some(function (excludedPath) {
    return asPath.startsWith(excludedPath);
  });
  useEffect(function () {
    // Note: the hope is to move this to Next's upcoming
    // Layout data fetching functionality
    var fetchBannerData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(geo) {
        var bannerItems, defaultBanner, regionBanner;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetchBannerItems(locale);

              case 2:
                bannerItems = _context2.sent;

                if (bannerItems.length > 0) {
                  defaultBanner = bannerItems.find(function (_ref4) {
                    var Region = _ref4.Region;
                    return Region === REGION_GLOBAL;
                  });
                  regionBanner = bannerItems.find(function (_ref5) {
                    var Region = _ref5.Region;

                    if (country === 'JP') {
                      var regionName = String(Region).replace(/\W+/g, '');
                      return regionName === geo.region_name;
                    }

                    return Region === geo.region_code;
                  }); // if website country and user location country match show banner, regional (if set) or global (if set)

                  if (geo.country_code === country && (regionBanner || defaultBanner)) {
                    setBannerData(regionBanner || defaultBanner); // if website country and user country don't match and the global banner is set, show it
                  } else if (geo.country_code !== country && defaultBanner) {
                    setBannerData(defaultBanner);
                  }
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function fetchBannerData(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    if (geoResponse) {
      void fetchBannerData(geoResponse);
    }
  }, [country, locale, geoResponse, prismicConfig]);

  if (isOnExcludedPage || !bannerData) {
    return null;
  }

  return /*#__PURE__*/_createElement(GiftBannerUI, _objectSpread(_objectSpread({}, props), {}, {
    bannerData: bannerData,
    key: "".concat(asPath, "-gift-banner")
  }));
};
var Wrap = styled.div.withConfig({
  componentId: "sc-m5wfra-0"
})(["position:fixed;inset:auto 0 0;z-index:", ";"], getZIndex('banner'));
var StyledCloseButton = styled(ButtonIcon).withConfig({
  componentId: "sc-m5wfra-1"
})(["background-color:rgb(255 255 255 / 50%);&:hover{background-color:", ";}"], getColor('base000'));
var StyledLink = styled(Link).withConfig({
  componentId: "sc-m5wfra-2"
})(["&&{font-size:", ";font-weight:", ";display:block;", "}"], getFontSize('bodyLg'), getFontWeight('semibold'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      display: inline-block;\n      margin: 0 0 0 ", ";\n    "])), getSpace('small3')));